import React from 'react';
import { GoogleOAuthProvider, GoogleLogin, CredentialResponse } from '@react-oauth/google';
import {jwtDecode} from 'jwt-decode'; // Corrected import statement
import { Center } from '@mantine/core';

const GoogleSignin = (props:{
    onGoogleAuthSuccess:(email:string,name:string)=>void;
}) => {

    const handleSuccess = (credentialResponse: CredentialResponse) => {
        const decodedToken = jwtDecode(credentialResponse?.credential || '') as any;
        
        props.onGoogleAuthSuccess(decodedToken.email,decodedToken.name)
    }

    const handleError = () => {
        console.log('Login Error');
    }

    return (
        <Center style={{ display: "flex", width: "100%" }}>
            <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID??""}>
                <GoogleLogin
                    onSuccess={handleSuccess}
                    onError={handleError}
                />
            </GoogleOAuthProvider>
        </Center>
    );
}

export default GoogleSignin;
